import { ActionModal } from '@kcftech/design-system';
import { IAssetCategoryResponse } from '@kcftech/prometheus-client';
import { useMutation } from '@tanstack/react-query';
import { useNotificationContext } from 'contexts/NotificationContext';
import { updateAssetCategory } from 'utils/asset_classification';

export type CategoryMoveInfo = Readonly<{
    category: IAssetCategoryResponse;
    parentCategory: IAssetCategoryResponse | undefined;
}>;

export type MoveAssetCategoryConfirmationModalProps = Readonly<{
    moveInfo: CategoryMoveInfo;
    onClose: (updatedCategory: IAssetCategoryResponse | undefined) => void;
}>;

export function MoveAssetCategoryConfirmationModal({
    moveInfo: { category, parentCategory },
    onClose,
}: MoveAssetCategoryConfirmationModalProps) {
    const { showToast } = useNotificationContext();
    const { mutate: moveCategory, isPending: isUpdating } = useMutation({
        meta: { name: 'update-asset-category' },
        mutationFn: async () =>
            updateAssetCategory(category.Id, {
                ParentCategoryId: parentCategory?.Id,
            }),

        onSuccess: (result) => {
            onClose(result);
            showToast({
                type: 'success',
                content: 'Successfully moved asset category',
            });
        },

        onError: () =>
            showToast({ type: 'error', content: 'Failed to move asset category' }),
    });

    const destination = parentCategory
        ? `category ${parentCategory.Name}`
        : 'be a top level category';

    return (
        <ActionModal
            title="Move Category"
            width={700}
            height={350}
            closeButtonText="Cancel"
            actionButtonText="Move"
            onAction={moveCategory}
            onClose={() => onClose(undefined)}
            showActionButton
            actionable={!isUpdating}
            closable={!isUpdating}
        >
            Are you sure you want to move category {category.ShortName}to {destination}?
        </ActionModal>
    );
}
